module.exports = __webpack_public_path__ + "img/electron-gold.c13b4cff.svg";